import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useRef, useEffect, useCallback } from 'react';
import { mergeRefs } from 'use-callback-ref';
import '../../utils/assertions.es.js';
import { callAllHandlers } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { useDisclosure } from '../../hooks/useDisclosure/useDisclosure.es.js';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var usePopover = function usePopover(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$isOpenDefault = _ref.isOpenDefault,
      isOpenDefault = _ref$isOpenDefault === void 0 ? false : _ref$isOpenDefault,
      onOpenProp = _ref.onOpen,
      onCloseProp = _ref.onClose,
      _ref$triggerEvent = _ref.triggerEvent,
      triggerEvent = _ref$triggerEvent === void 0 ? "click" : _ref$triggerEvent,
      triggerRef = _ref.triggerRef,
      hasArrow = _ref.hasArrow,
      placement = _ref.placement,
      _ref$closeOnBlur = _ref.closeOnBlur,
      closeOnBlur = _ref$closeOnBlur === void 0 ? true : _ref$closeOnBlur,
      closeDelay = _ref.closeDelay;

  var _useDisclosure = useDisclosure({
    defaultIsOpen: isOpenDefault,
    onOpen: onOpenProp,
    onClose: onCloseProp
  }),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose,
      onToggle = _useDisclosure.onToggle;

  var isHoveringRef = useRef(false);
  var closeTimeout = useRef();
  var anchorRef = useRef(null);
  useEffect(function () {
    return function () {
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  var getTriggerProps = useCallback(function (_temp2, forwardedRef) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$onClick = _ref2.onClick,
        onClick = _ref2$onClick === void 0 ? function () {
      return void 0;
    } : _ref2$onClick,
        _ref2$onMouseEnter = _ref2.onMouseEnter,
        onMouseEnter = _ref2$onMouseEnter === void 0 ? function () {
      return void 0;
    } : _ref2$onMouseEnter,
        _ref2$onMouseLeave = _ref2.onMouseLeave,
        onMouseLeave = _ref2$onMouseLeave === void 0 ? function () {
      return void 0;
    } : _ref2$onMouseLeave;

    if (forwardedRef === void 0) {
      forwardedRef = null;
    }

    return __spreadProps(__spreadValues({
      role: "button",
      "aria-haspopup": "true",
      "aria-expanded": isOpen
    }, !triggerRef && {
      onClick: triggerEvent === "click" ? callAllHandlers(onClick, onToggle) : onClick,
      onMouseEnter: triggerEvent === "hover" ? callAllHandlers(onMouseEnter, function () {
        isHoveringRef.current = true;
        onOpen();
      }) : onMouseEnter,
      onMouseLeave: triggerEvent === "hover" ? callAllHandlers(onMouseLeave, function () {
        isHoveringRef.current = false;
        closeTimeout.current = window.setTimeout(function () {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      }) : onMouseLeave
    }), {
      ref: mergeRefs([forwardedRef, anchorRef])
    });
  }, [closeDelay, isOpen, onClose, onOpen, onToggle, triggerEvent, triggerRef]);
  var getPopoverProps = useCallback(function (_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        _ref3$onMouseEnter = _ref3.onMouseEnter,
        onMouseEnter = _ref3$onMouseEnter === void 0 ? function () {
      return void 0;
    } : _ref3$onMouseEnter,
        _ref3$onMouseLeave = _ref3.onMouseLeave,
        onMouseLeave = _ref3$onMouseLeave === void 0 ? function () {
      return void 0;
    } : _ref3$onMouseLeave;

    var handleClickOutside = function handleClickOutside() {
      closeOnBlur && onClose();
    };

    return {
      anchorRef: anchorRef,
      isOpen: isOpen,
      triggerRef: triggerRef,
      hasArrow: hasArrow,
      placement: placement,
      onClickOutside: handleClickOutside,
      onMouseEnter: triggerEvent === "hover" ? callAllHandlers(onMouseEnter, function () {
        isHoveringRef.current = true;
      }) : onMouseEnter,
      onMouseLeave: triggerEvent === "hover" ? callAllHandlers(onMouseLeave, function () {
        isHoveringRef.current = false;
        closeTimeout.current = window.setTimeout(function () {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      }) : onMouseLeave
    };
  }, [closeDelay, closeOnBlur, hasArrow, isOpen, onClose, placement, triggerEvent, triggerRef]);
  return {
    isOpen: isOpen,
    anchorRef: anchorRef,
    toggle: onToggle,
    open: onOpen,
    close: onClose,
    getTriggerProps: getTriggerProps,
    getPopoverProps: getPopoverProps
  };
};

export { usePopover };